import {
  ecogreen,
  techblue,
  success,
  warning,
  error,
  charcoal,
  moss,
  stone,
  green,
  yellow,
  pink,
  purple,
  blue,
  sky,
  cyan,
  toxic,
  orange,
  red
} from "./colors/colors"

import { svSE } from "@mui/material/locale"
import imageFile from "./eco-mobility-small.svg"
import accordionStyle from "./elements/accordion"
import { createTheme } from "@mui/material/styles"
import typographyStyle from "./elements/typography"
import brightenergy from "./colors/brightenergy"

const image = {
  src: imageFile,
  alt: "route-logo"
}

const defaultTheme = createTheme()

const theme = createTheme({
  typography: typographyStyle,
  logo: image,
  palette: {
    text: {
      primary: charcoal[900],
      secondary: charcoal[500]
    },
    mode: "light",
    primary: {
      ...techblue,
      main: techblue[600],
      light: techblue[100],
      dark: techblue[700],
      contrastText: techblue.contrastDefaultColor,
      buttonContainedBackgroundColor: techblue[600],
      buttonContainedTextColor: ecogreen[600],
      buttonContainedHoverBackgroundColor: techblue[400],
      buttonContainedHoverTextColor: ecogreen[600],
      buttonOutlinedBackgroundColor: "transparent",
      buttonOutlinedTextColor: ecogreen[600],
      buttonOutlinedHoverBackgroundColor: techblue[300],
      buttonOutlinedHoverTextColor: ecogreen[600],
      buttonOutlinedBorderColor: ecogreen[300],
      buttonOutlinedHoverBorderColor: ecogreen[300],
      buttonTextTextColor: ecogreen[600],
      buttonTextBackgroundColor: "transparent",
      buttonTextHoverBackgroundColor: techblue[500],
      buttonTextHoverTextColor: ecogreen[600],
      tonalBackgroundColor: techblue[300],
      tonalHoverBackgroundColor: techblue[500],
      tonalTextColor: ecogreen[600],
      tonalHoverTextColor: ecogreen[600]
    },
    primaryLight: {
      main: techblue[300],
      contrastText: ecogreen[600]
    },
    primaryMain: {
      main: techblue[500],
      contrastText: ecogreen[600]
    },
    primaryDark: {
      main: techblue[700],
      contrastText: ecogreen[900]
    },
    secondary: {
      ...ecogreen,
      main: ecogreen[600],
      light: ecogreen[100],
      dark: ecogreen[700],
      contrastText: ecogreen.contrastDefaultColor,
      buttonContainedBackgroundColor: ecogreen[600],
      buttonContainedTextColor: brightenergy[100],
      buttonContainedHoverBackgroundColor: ecogreen[500],
      buttonContainedHoverTextColor: brightenergy[200],
      buttonOutlinedBackgroundColor: "transparent",
      buttonOutlinedTextColor: ecogreen[600],
      buttonOutlinedHoverBackgroundColor: ecogreen[200],
      buttonOutlinedHoverTextColor: ecogreen[600],
      buttonOutlinedBorderColor: ecogreen[300],
      buttonOutlinedHoverBorderColor: ecogreen[300],
      buttonTextTextColor: ecogreen[600],
      buttonTextBackgroundColor: "transparent",
      buttonTextHoverBackgroundColor: techblue[500],
      buttonTextHoverTextColor: ecogreen[600],
      tonalBackgroundColor: ecogreen[200],
      tonalHoverBackgroundColor: ecogreen[300],
      tonalTextColor: ecogreen[600],
      tonalHoverTextColor: ecogreen[800]
    },
    secondaryLight: {
      main: ecogreen[200],
      contrastText: ecogreen[600]
    },
    secondaryMain: {
      main: ecogreen[300],
      contrastText: ecogreen[600]
    },
    secondaryDark: {
      main: ecogreen[600],
      contrastText: brightenergy[400]
    },
    success: {
      ...success,
      main: success[600],
      light: success[100],
      dark: success[700],
      contrastText: success.contrastDefaultColor,
      buttonOutlinedTextColor: success[600],
      buttonOutlinedHoverBackgroundColor: green[200],
      buttonOutlinedHoverTextColor: success[600],
      buttonOutlinedBorderColor: green[400],
      buttonOutlinedHoverBorderColor: success[600],
      buttonContainedBackgroundColor: success[600],
      buttonContainedTextColor: success[100],
      buttonContainedHoverBackgroundColor: success[700],
      buttonContainedHoverTextColor: success[100],
      tonalBackgroundColor: green[200],
      tonalHoverBackgroundColor: success[600],
      tonalTextColor: ecogreen[700],
      tonalHoverTextColor: green[400]
    },
    warning: {
      ...warning,
      main: warning[600],
      light: warning[100],
      dark: warning[700],
      contrastText: warning.contrastDefaultColor,
      buttonOutlinedTextColor: warning[400],
      buttonOutlinedHoverTextColor: warning[600],
      buttonOutlinedHoverBackgroundColor: warning[100],
      buttonOutlinedBorderColor: warning[400],
      buttonOutlinedHoverBorderColor: warning[600],
      buttonContainedBackgroundColor: warning[600],
      buttonContainedTextColor: warning[100],
      buttonContainedHoverBackgroundColor: warning[700],
      buttonContainedHoverTextColor: warning[200],
      tonalBackgroundColor: warning[100],
      tonalHoverBackgroundColor: warning[200],
      tonalTextColor: warning[600],
      tonalHoverTextColor: warning[600]
    },
    error: {
      ...error,
      main: error[600],
      light: error[100],
      dark: error[700],
      contrastText: error.contrastDefaultColor,
      buttonOutlinedTextColor: error[600],
      buttonOutlinedHoverBackgroundColor: "transparent",
      buttonOutlinedHoverTextColor: error[100],
      buttonOutlinedBorderColor: error[600],
      buttonOutlinedHoverBorderColor: error[600],
      buttonContainedBackgroundColor: error[600],
      buttonContainedTextColor: error[100],
      buttonContainedHoverBackgroundColor: error[700],
      buttonContainedHoverTextColor: error[200],
      tonalBackgroundColor: error[100],
      tonalHoverBackgroundColor: error[200],
      tonalTextColor: error[600],
      tonalHoverTextColor: error[700]
    },
    info: {
      ...stone,
      main: stone[600],
      light: stone[100],
      dark: stone[700],
      contrastText: stone.contrastDefaultColor
    },
    default: {
      ...charcoal,
      main: charcoal[600],
      light: charcoal[100],
      dark: charcoal[700],
      contrastText: charcoal.contrastDefaultColor
    },
    foreground: {
      default: "#000000",
      inverted: "#ffffff"
    },
    background: {
      default: charcoal[100],
      paper: "#ffffff",
      inverted: ecogreen[900],
      secondary: ecogreen[300],
      dark: ecogreen[700],
      light: ecogreen[100]
    },
    brightenergy: {
      ...brightenergy,
      main: brightenergy[600]
    },
    moss: {
      ...moss,
      main: moss[600]
    },
    green: {
      ...green,
      main: green[900]
    },
    orange: {
      ...orange,
      main: orange[900]
    },
    red: {
      ...red,
      main: red[900]
    },
    grey: {
      ...charcoal,
      main: charcoal[600]
    },
    pink: {
      ...pink,
      main: pink[600]
    },
    yellow: {
      ...yellow,
      main: yellow[600]
    },
    purple: {
      ...purple,
      main: purple[600]
    },
    blue: {
      ...blue,
      main: blue[600]
    },
    sky: {
      ...sky,
      main: sky[600]
    },
    cyan: {
      ...cyan,
      main: cyan[600]
    },
    toxic: {
      ...toxic,
      main: toxic[600]
    }
  },
  tabs: {
    backgroundColor: techblue[600]
  },
  components: {
    MuiLink: {
      defaultProps: {
        underline: "hover"
      }
    },
    MuiCssBaseline: {
      "@global": {
        "*::-webkit-scrollbar": {
          width: "20px",
          height: "20px"
        },
        "*::-webkit-scrollbar-track ": {
          backgroundColor: "transparent"
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: ecogreen[400],
          borderRadius: "20px",
          border: "6px solid transparent",
          backgroundClip: "content-box"
        },
        "*::-webkit-scrollbar-thumb:hover ": {
          backgroundColor: ecogreen[500]
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme, ownerState }) => {
          const paletteKey = ownerState.color || "secondary"
          return {
            color: theme.palette[paletteKey]?.[700] || theme.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: theme.palette[paletteKey]?.[200] || theme.palette.primary.contrastText
            }
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ theme, ownerState }) => {
          const paletteKey = ownerState.color || "primary"
          const variant = ownerState.variant || "text"

          let bgColor, hoverColor, textColor, hoverTextColor, borderColor, hoverBorderColor

          if (variant === "contained") {
            bgColor =
              theme.palette[paletteKey]?.buttonContainedBackgroundColor ||
              theme.palette[paletteKey]?.[600] ||
              theme.palette.primary[600]
            hoverColor =
              theme.palette[paletteKey]?.buttonContainedHoverBackgroundColor ||
              theme.palette[paletteKey]?.[500] ||
              theme.palette.primary[500]
            textColor =
              theme.palette[paletteKey]?.buttonContainedTextColor ||
              theme.palette[paletteKey]?.contrastText ||
              theme.palette.primary.contrastText
            hoverTextColor = theme.palette[paletteKey]?.buttonContainedHoverTextColor || textColor
            borderColor = "none"
          } else if (variant === "outlined") {
            bgColor = theme.palette[paletteKey]?.buttonOutlinedBackgroundColor || "transparent"
            hoverColor =
              theme.palette[paletteKey]?.buttonOutlinedHoverBackgroundColor ||
              theme.palette[paletteKey]?.[100] ||
              theme.palette.primary[300]
            textColor =
              theme.palette[paletteKey]?.buttonOutlinedTextColor ||
              theme.palette[paletteKey]?.[600] ||
              theme.palette.secondary[600]
            hoverTextColor = theme.palette[paletteKey]?.buttonOutlinedHoverTextColor || textColor
            borderColor =
              theme.palette[paletteKey]?.buttonOutlinedBorderColor ||
              theme.palette[paletteKey]?.[300] ||
              theme.palette.secondary[300]
            hoverBorderColor = theme.palette[paletteKey]?.buttonOutlinedHoverBorderColor || borderColor
          } else if (variant === "text") {
            bgColor = theme.palette[paletteKey]?.buttonTextBackgroundColor || "transparent"
            hoverColor =
              theme.palette[paletteKey]?.buttonTextHoverBackgroundColor ||
              theme.palette[paletteKey]?.[500] ||
              theme.palette.primary[500]
            textColor =
              theme.palette[paletteKey]?.buttonTextTextColor ||
              theme.palette[paletteKey]?.[600] ||
              theme.palette.primary[600]
            hoverTextColor = theme.palette[paletteKey]?.buttonTextHoverTextColor || textColor
            borderColor = "none"
          } else if (variant === "tonal") {
            bgColor =
              theme.palette[paletteKey]?.tonalBackgroundColor ||
              theme.palette[paletteKey]?.[200] ||
              theme.palette.primary[200]
            hoverColor =
              theme.palette[paletteKey]?.tonalHoverBackgroundColor ||
              theme.palette[paletteKey]?.[300] ||
              theme.palette.primary[300]
            textColor =
              theme.palette[paletteKey]?.tonalTextColor ||
              theme.palette[paletteKey]?.[600] ||
              theme.palette.primary[600]
            hoverTextColor = theme.palette[paletteKey]?.tonalHoverTextColor || textColor
            borderColor = "none"
          } else {
            bgColor = "transparent"
            hoverColor = theme.palette[paletteKey]?.[100] || theme.palette.primary[100]
            textColor = theme.palette[paletteKey]?.[600] || theme.palette.primary[600]
            hoverTextColor = textColor
            borderColor = "none"
          }

          return {
            color: textColor,
            textTransform: "none",
            fontWeight: 600,
            boxShadow: "none",
            backgroundColor: bgColor,
            border: variant === "outlined" ? `1px solid ${borderColor}` : "none",
            "&:hover": {
              backgroundColor: hoverColor,
              color: hoverTextColor,
              boxShadow: "none",
              transform: "none",
              border: variant === "outlined" ? `1px solid ${hoverBorderColor}` : "none"
            }
          }
        },
        sizeSmall: ({ theme, ownerState }) => ({
          gap: ownerState.startIcon || ownerState.endIcon ? 0 : "6px",
          boxShadow: "none",
          borderRadius: "6px",
          height: "32px",
          padding: "6px 12px",
          fontSize: theme.typography.labelSmall.fontSize
        }),
        sizeMedium: ({ theme, ownerState }) => ({
          gap: ownerState.startIcon || ownerState.endIcon ? 0 : "8px",
          boxShadow: "none",
          borderRadius: "6px",
          height: "40px",
          padding: "8px 16px",
          fontSize: theme.typography.labelMedium.fontSize
        }),
        sizeLarge: ({ theme, ownerState }) => ({
          gap: ownerState.startIcon || ownerState.endIcon ? 0 : "12px",
          boxShadow: "none",
          borderRadius: "10px",
          height: "48px",
          padding: "10px 18px",
          fontSize: theme.typography.labelLarge.fontSize
        })
      }
    },

    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: 40,
          paddingBottom: 40
        },
        maxWidthLg: {
          [defaultTheme.breakpoints.up("lg")]: {
            maxWidth: "100%"
          }
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          [defaultTheme.breakpoints.up("sm")]: {
            minWidth: "100px"
          },
          [defaultTheme.breakpoints.up("md")]: {
            minWidth: "115px"
          },
          "&.Mui-selected": { fontWeight: 700, color: charcoal[900] }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: techblue[700]
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: ecogreen[700],
          color: "white"
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          "& .MuiList-root": {
            "& .MuiListItem-root": {
              borderRadius: "0.3rem 0 0 0.3rem",
              minHeight: "46px"
            },
            "& .MuiListItemText-root": {
              margin: 0
            }
          },
          "& .MuiTab-labelIcon": {
            color: "white",
            minWidth: "auto",
            fontWeight: 400
          },
          "& .MuiTypography-caption": {
            color: charcoal[500]
          },
          "& .Mui-selected": {
            backgroundColor: charcoal[400],
            fontWeight: 700
          }
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: ecogreen[200],
          "&.Mui-completed": {
            color: ecogreen[500]
          },
          "&.Mui-active": {
            color: ecogreen[500]
          }
        },
        active: {}
      }
    },
    MuiStepLabel: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-iconContainer": {
            paddingRight: "11px"
          }
        }
      }
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-lineVertical": {
            border: "none"
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0px 0px 65px 0px rgb(0 0 0 / 6%)",
          borderRadius: "8px"
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          marginLeft: "-11px",
          color: techblue[800],
          "&.Mui-checked": {
            color: techblue[800]
          }
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: techblue[800],
          "&.Mui-checked": {
            color: techblue[800]
          }
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 42,
          height: 26,
          padding: 0,
          marginRight: 8
        },

        switchBase: ({ theme }) => ({
          padding: 0,
          margin: 2,
          transitionDuration: "300ms",
          "&.Mui-checked": {
            transform: "translateX(16px)",
            color: theme.palette.foreground.inverted,
            "& + .MuiSwitch-track": {
              backgroundColor: theme.palette.primary.main,
              opacity: 1,
              border: `1px solid ${theme.palette.primary[800]}`
            },
            "&.Mui-disabled + .MuiSwitch-track": {
              opacity: 0.5
            }
          },
          "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: theme.palette.primary[800],
            border: `6px solid ${theme.palette.foreground.inverted}`
          },
          "&.Mui-disabled .MuiSwitch-thumb": {
            color: theme.palette.grey[100]
          },
          "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.7
          }
        }),
        thumb: {
          boxSizing: "border-box",
          width: 22,
          height: 22
        },

        track: ({ theme }) => ({
          border: `1px solid ${theme.palette.grey[400]}`,
          borderRadius: 26 / 2,
          backgroundColor: theme.palette.grey[300],
          opacity: 1,
          transition: theme.transitions.create(["background-color"], {
            duration: 500
          })
        })
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          margin: "0px"
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: ecogreen[600]
          },
          "&.Mui-hover": {
            backgroundColor: ecogreen[600]
          },
          "&.Mui-disabled": {
            borderColor: charcoal[300],
            color: charcoal[300]
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: ecogreen[600]
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: charcoal[500],
          "&.Mui-focused": {
            color: ecogreen[600]
          }
        }
      }
    },

    MuiPickersMonth: {
      styleOverrides: {
        monthButton: {
          "&.Mui-selected": {
            backgroundColor: techblue[700],
            color: "#fff"
          }
        }
      }
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: {
          "&.Mui-selected": {
            backgroundColor: techblue[700],
            color: "#fff"
          }
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          "&.MuiPickersDay-today": {
            color: `${techblue[700]} !important`,
            borderColor: techblue[700]
          },
          "&.Mui-selected": {
            color: "#fff !important",
            backgroundColor: techblue[700]
          },
          "&.MuiPickersDay-today > span": {
            borderColor: `${techblue[700]} !important`
          },
          "&.MuiButtonBase-root-MuiPickersDay-root.MuiPickersDay-today > span": {
            borderColor: techblue[700]
          },
          "&.MuiButtonBase-root-MuiPickersDay-root.MuiPickersDay-today": {
            color: `${techblue[700]} !important`
          }
        }
      }
    },
    MuiPickersWeek: {
      styleOverrides: {
        root: {
          "&.MuiButtonBase-root-MuiPickersDay-root.MuiPickersDay-today": {
            color: `${techblue[700]} !important`
          }
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: charcoal[700],
          color: "#fff"
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "& hover": {
            backgroundColor: `${ecogreen[500]} !important`
          },
          "&.Mui-selected": {
            backgroundColor: `${ecogreen[100]} !important`
          },
          "&.Mui-selected:hover": {
            backgroundColor: `${ecogreen[100]} !important`
          }
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: charcoal[300]
        }
      }
    },
    "MuiLinearProgress-root": {
      "&.MuiMobileStepper-progress": {
        backgroundColor: charcoal[200]
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiChip-root": {
            backgroundColor: ecogreen[100],
            color: charcoal[700]
          },
          "& .MuiChip-deleteIcon": {
            color: `${ecogreen[400]} !important`,
            "&:hover": {
              color: `${ecogreen[600]} !important`
            }
          }
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        outlined: ({ theme, ownerState }) => {
          const paletteKey = ownerState.severity ?? ownerState.color ?? "primary"

          return {
            borderRadius: "6px",
            border: `1px solid ${theme.palette[paletteKey].main}`,
            backgroundColor: theme.palette[paletteKey].light,
            color: theme.palette[paletteKey].dark
          }
        }
      }
    },

    MuiAccordion: accordionStyle
  },
  svSE
})
export default theme
